import ICustomForm from "../../ICustomForm";
import m, {Vnode} from "mithril";
import ImageHighlighterCF from "../ImageHighlighterCF";
import ICustomFormSettings from "../../ICustomFormSettings";

export default class ImageHighlighterComment extends ImageHighlighterCF implements ICustomForm
{

    constructor(settings: ICustomFormSettings) {
        super(settings);

        if (this.imageWithHighlighter) {
            this.imageWithHighlighter.highlighter.comments = true;
        }
    }


    view(): Vnode {
        return this.viewLayout([
            this.imageWithHighlighter.getView(),
            ...this.checkboxes.map( ch => m(ch) ),
        ]);
    }

}
